import _ from 'lodash';
import { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { Button } from '../DanitComponents/Buttons/Button';
import DropdownFilter from '../DanitComponents/Dropdown/DropdownFilter';
import SearchInput from '../DanitComponents/Inputs/SearchInput';
import ShortToggle from '../DanitComponents/Toggles/ShortToggle';
import { FilterTypeId } from './filters-type';
import './search-header.css';
import { MdExpandMore } from 'react-icons/md';
import ModalDropdownMenuFall2023 from '../StudentOnboardingCardModalFall2023/ModalAreaFall2023/ModalDropdownMenuFall2023/ModalDropdownMenuFall2023';

const SearchHeader = ({title, dropdownTitle, cta, cta2, cta3, filters = [], onChangeQuery, onChangeFilters, onClickCta, onClickCta2, onClickCta3, clearAll}) => {
  // Query
  const [query, setQuery] = useState('');
  // Dropdown
  const [dropdownMenu, setDropdownMenu] = useState(false);
  useEffect(() => {
    onChangeQuery && onChangeQuery(query)
  }, [query, onChangeQuery]);
  // Filters
  const defaultFilterState = filters.map(filter => {
      return {
        filterId: filter.id,
        value: filter.type === FilterTypeId.Dropdown ? [] : false
      }
  })

  useEffect(() => {
    //if one of the filters is type SelectDropDown, set the default value to the first option
    const selectDropDownFilter = filters.find(filter => filter.type === FilterTypeId.SelectDropDown);
    if(selectDropDownFilter && selectDropDownFilter.options.length > 0) {
      setFilterState({
        ...filterState,
        [selectDropDownFilter.id]: selectDropDownFilter.options[0].id
      })
    }
  }, [filters[0].options])

  const [filterState, setFilterState] = useState(defaultFilterState);
  
  const updateFilter = (filterId, newValue) => {
    setFilterState({
      ...filterState,
      [filterId]: newValue
    })
  }

  const clearAllFilters = () => {
    setFilterState(defaultFilterState);
    setQuery('');
  }

  useEffect(() => {
    onChangeFilters && onChangeFilters(filterState);
  }, [filterState, onChangeFilters]);

  const isFilterActive = (id) => {
    const value = filterState[id];
    return value === true || (Array.isArray(value) && value.length > 0);
  }

  const labelColorClass = (id) => `text-${isFilterActive(id) ? 'blue' : 'slate'}-500`

  const filtersEmpty = _.isEqual(filterState, {});

    return <div className='search-header'>
      <div className="flex justify-between items-center mb-5">
        <div>
            {title && !dropdownTitle && <h1 className='search-header-title'>{title}</h1>}
            {title && dropdownTitle && 
              <div className='search-header__wrapper'>
                <h2 className='search-header-dropdown-title__top-title'>{title}</h2>
                <div className='search-header-dropdown-title__wrapper'>
                  <h1 className='search-header-dropdown-title'>{dropdownTitle}</h1>
                  <div className='search-header-dropdown-menu__button__wrapper'>
                    <MdExpandMore color='#94A3B8' size={24} onClick={() => setDropdownMenu(!dropdownMenu)} />
                    {dropdownMenu && 
                      <div className='search-header-dropdown-menu__wrapper'>
                        <ModalDropdownMenuFall2023 menuItems={[]} setOpenDropdown={setDropdownMenu} sections={false} />
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
        </div>
        <div className='search-header__button-wrapper'>
            {cta && <Button text={cta} action={onClickCta} color={'secondary'} startIcon={BsPlus}/>}
            {cta2 && <Button text={cta2} action={onClickCta2} color={'secondary'} startIcon={BsPlus}/>}
            {cta3 && <Button text={cta3} action={onClickCta3} color={'secondary'} startIcon={BsPlus} />}
        </div>
      </div>
      <div className={`flex justify-between items-end gap-5 flex-wrap`}>
        {!onChangeQuery && <div></div>}
        {onChangeQuery &&  <div className='search-header-input-wrapper'>
            <SearchInput value={query} onChange={value => setQuery(value)}/>
        </div>}
        {filters && <div className="flex items-center gap-1 text-sm text-slate-700 h-8">
        {filters.map(filter => <div className='flex gap-2 items-center' key={filter.id}>
          {filter.type === FilterTypeId.Switch && <div className='flex items-center gap-2 mr-2.5'><div className={`${labelColorClass(filter.id)} text-sm font-semibold`}>{filter.label}</div><ShortToggle color='info' value={filterState[filter.id]} onChange={value => updateFilter(filter.id, value)}/></div>}
          {filter.type === FilterTypeId.Dropdown && <DropdownFilter label={filter.label} options={filter.options} value={filterState[filter.id]} onChange={value => updateFilter(filter.id, value)}/>}
          {filter.type === FilterTypeId.SelectDropDown && <select className='p-2 border-none w-40 rng text-gray-700 focus:ring-0 bg-slate-50' onChange={e => updateFilter(filter.id, e.target.value)} value={filterState[filter.id]}>{filter.options.map((option, index) => <option key={index} value={option.id}>{option.label}</option>)}</select>}
        </div>)}
        {clearAll && <Button text="Clear All" variant={'link'} color={'neutral'} action={() => clearAllFilters()} isDisabled={filtersEmpty}/>}
        </div>}
      </div>
    </div>
}

export default SearchHeader;